import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { quickOrderProductListStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderProductList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

quickOrderProductListStyles.totalText = mergeToNew(quickOrderProductListStyles.totalText, {
    css: css`
        color: ${getColor("secondary.contrast")};
        float: right;
        font-weight: bold;
        margin: 15px 0;
    `,
});

quickOrderProductListStyles.extendedPriceText = mergeToNew(quickOrderProductListStyles.extendedPriceText, {
    css: css`
        color: ${getColor("secondary.contrast")};
        font-weight: bold;
        align-self: center;
    `,
});

quickOrderProductListStyles.price = mergeToNew(quickOrderProductListStyles.price, {
    wrapper: {
        css: css`
            > div {
                flex-wrap: wrap;
                display: flex;
                margin-top: 0;
            }
        `,
    },
    price: {
        priceText: {
            size: 16,
        },
    },
});

quickOrderProductListStyles.quantityGridItem = mergeToNew(quickOrderProductListStyles.quantityGridItem, {
    width: [6, 6, 3, 3, 4],
});

quickOrderProductListStyles.priceAndQuantityGridItem = mergeToNew(
    quickOrderProductListStyles.priceAndQuantityGridItem,
    {
        width: [12, 12, 12, 12, 7],
    },
);

quickOrderProductListStyles.priceAndQuantityContainer = mergeToNew(
    quickOrderProductListStyles.priceAndQuantityContainer,
    {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
);

quickOrderProductListStyles.productImage = mergeToNew(quickOrderProductListStyles.productImage, {
    img: {
        css: css`
            height: auto;
            width: auto;
            max-height: 133px;
            max-width: 100%;
        `,
    },
});

quickOrderProductListStyles.productImageGridItem = mergeToNew(quickOrderProductListStyles.productImageGridItem, {
    width: [2, 2, 2, 1, 1],
});

quickOrderProductListStyles.productInfoGridItem = mergeToNew(quickOrderProductListStyles.productInfoGridItem, {
    width: [7, 7, 7, 9, 9],
});

quickOrderProductListStyles.extendedPriceGridItem = mergeToNew(quickOrderProductListStyles.extendedPriceGridItem, {
    width: [6, 6, 3, 3, 3],
});

quickOrderProductListStyles.priceGridItem = mergeToNew(quickOrderProductListStyles.priceGridItem, {
    width: [12, 12, 4, 4, 5],
});
